import * as yup from "yup";
import {isValidUrl} from "../valid-url";

yup.addMethod<yup.StringSchema>(
  yup.string,
  "urlWithEmoji",
  function (message = "URL is not valid") {
    return this.test(
      "url-with-emoji",
      message,
      (value) => (value ? isValidUrl(value) : true) // empty→pass when field optional
    );
  }
);

// 1️⃣  Add a reusable method ✨
yup.addMethod<yup.StringSchema>(
  yup.string,
  "noSpaces",
  function noSpaces(message = "Spaces are not allowed") {
    return this.test(
      "no-spaces", // ✅ known parameter
      message, // ✅ error message
      (value) =>
        value == null || // let .required() deal with empties
        !/\s/.test(value) // fail only when a space is present
    );
  }
);

export default yup;
